import { api } from '../api/client';
import { AUTH } from '../api/endpoints';

export const authService = {
  login: (login, password) => api.post(AUTH.LOGIN, { login, password }),
  signup: (body) => api.post(AUTH.SIGNUP, body),
  me: () => api.get(AUTH.ME),
  engagement: () => api.get(AUTH.ENGAGEMENT),
  updateMe: (body) => api.patch(AUTH.UPDATE_ME, body),
  changePassword: (body) => api.post(AUTH.CHANGE_PASSWORD, body),
};
